// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__25IxP","inner":"Form_inner__2QKd7","range":"Form_range__19LR5","name":"Form_name__D3DnG","actions":"Form_actions__2JjYs"};